import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Field = ({ label, children }) => (
  <label className="block">
    <span className="font-mono text-[10px] uppercase tracking-widest text-ink/50">{label}</span>
    {children}
  </label>
);

export const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", company: "", phone: "", email: "", message: "", privacy: false });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.name.trim().length < 2 || form.phone.trim().length < 6 || !/^\S+@\S+\.\S+$/.test(form.email) || form.message.trim().length < 5) {
      toast.error("Compila tutti i campi obbligatori con dati validi");
      return;
    }
    if (!form.privacy) {
      toast.error("Accetta il trattamento dei dati per continuare");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contatti`, { ...form, company: form.company || null });
      toast.success("Messaggio inviato! Ti risponderemo al più presto.");
      setForm({ name: "", company: "", phone: "", email: "", message: "", privacy: false });
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invio non riuscito. Riprova o chiamaci.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-6 sm:grid-cols-2" data-testid="contact-form" noValidate>
      <Field label="Nome e cognome *">
        <input required minLength={2} value={form.name} onChange={set("name")} placeholder="Mario Rossi" className="field" data-testid="contact-form-name-input" />
      </Field>
      <Field label="Azienda">
        <input value={form.company} onChange={set("company")} placeholder="Impresa Edile Srl" className="field" data-testid="contact-form-company-input" />
      </Field>
      <Field label="Telefono *">
        <input required type="tel" minLength={6} value={form.phone} onChange={set("phone")} placeholder="+39 333 000 0000" className="field" data-testid="contact-form-phone-input" />
      </Field>
      <Field label="Email *">
        <input required type="email" value={form.email} onChange={set("email")} placeholder="nome@azienda.it" className="field" data-testid="contact-form-email-input" />
      </Field>
      <div className="sm:col-span-2">
        <Field label="Messaggio *">
          <textarea required minLength={5} rows={4} value={form.message} onChange={set("message")} placeholder="Come possiamo aiutarti?" className="field resize-none" data-testid="contact-form-message-input" />
        </Field>
      </div>
      <label className="flex items-start gap-3 text-xs text-ink/60 sm:col-span-2">
        <input type="checkbox" checked={form.privacy} onChange={set("privacy")} className="mt-0.5 h-4 w-4 accent-blue-600" data-testid="contact-form-privacy-checkbox" />
        Acconsento al trattamento dei dati personali per essere ricontattato in merito alla mia richiesta.
      </label>
      <div className="sm:col-span-2">
        <button type="submit" disabled={loading} className="btn-dark w-full disabled:opacity-60 sm:w-auto" data-testid="contact-form-submit-button">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Invia messaggio <ArrowRight className="h-4 w-4" /></>}
        </button>
      </div>
    </form>
  );
};
